import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-esi-compliance-view',
  templateUrl: './esi-compliance-view.component.html',
  styleUrls: ['./esi-compliance-view.component.css']
})
export class EsiComplianceViewComponent implements OnInit {
  title="ESI Compliance Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/esi-compliances/esi-compliance-view/esi-compliance-view.component.ts